export default __webpack_public_path__ + "static/media/Venturer's Treads of Pierced Flesh.64c94f2d.jpg";